import { Box, Card, CardContent, Typography, Link, Collapse, IconButton, Chip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DASH_PLACEHOLDER } from '../../utils/missingValue';
import type { SPLotInfo } from './types';

type Props = {
    spLotInfo: SPLotInfo;
    expandedInfo: boolean;
    setExpandedInfo: (v: boolean) => void;
    setMaterialDialogOpen: (v: boolean) => void;
    classes: any;
    getCropNameByCode: (code: string) => string;
};

const ProcessingInfoCard = ({ spLotInfo, expandedInfo, setExpandedInfo, setMaterialDialogOpen, classes, getCropNameByCode }: Props) => {
    return (
        <>
            <Card sx={{ width: '100%', minHeight: 38, mb: expandedInfo ? '4px' : '5px', boxShadow: 'none', border: '1px solid #C4C4C4', cursor: 'pointer', background: '#FFFFFF', opacity: 1, gap: '10px', margin: '0 auto' }} onClick={() => setExpandedInfo(!expandedInfo)}>
                <CardContent sx={{ p: '10px', '&:last-child': { pb: '10px' }, display: 'flex', alignItems: 'center', minHeight: 38 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Typography variant="subtitle1" className={classes.labelNoto16Bold400_hh}>SP Lot Information</Typography>
                        <IconButton size="small" sx={{ color: '#666', transform: expandedInfo ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
                            <KeyboardArrowDownIcon />
                        </IconButton>
                    </Box>
                </CardContent>
            </Card>
            <Box sx={{ height: 4 }} />
            <Collapse in={expandedInfo}>
                <Card sx={{ width: '100%', minHeight: 118, mb: '5px', boxShadow: 'none', border: '1px solid #C4C4C4', background: '#FFFFFF', borderBottomRightRadius: '4px', borderBottomLeftRadius: '4px', borderTopLeftRadius: 0, borderTopRightRadius: 0, opacity: 1, gap: '10px', margin: '0 auto' }}>
                    <CardContent sx={{ p: '10px 10px 16px 10px', '&:last-child': { pb: '16px' } }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <img src="icons/seedextraction_icon.png" alt="Crop" style={{ width: 12, height: 12, marginBottom: '4px', display: 'block' }} />
                                <Typography variant="body2" color="#4A5565" className={classes.labelNoto12Bold400_hh}>Crop:</Typography>
                                <Typography color="#101828" className={classes.labelNoto12Bold500_hh} sx={{ ml: '-3px', overflowWrap: 'anywhere' }}>{getCropNameByCode(spLotInfo.cropCode)}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <img src="icons/sector_icon.png" alt="Site" style={{ width: 12, height: 12, marginBottom: '4px', display: 'block' }} />
                                <Typography variant="body2" color="#4A5565" className={classes.labelNoto12Bold400_hh}>Site:</Typography>
                                <Typography className={classes.labelNoto12Bold500_hh} sx={{ ml: '-3px', overflowWrap: 'anywhere' }}>{spLotInfo.siteCode}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <img src="icons/materials_icon.png" alt="Material" style={{ width: 12, height: 12, marginTop: '3px', display: 'block' }} />
                                <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="body2" color="#4A5565" className={classes.labelNoto12Bold400_hh} sx={{ whiteSpace: 'nowrap' }}>Material IDs ({spLotInfo.materials.length}):</Typography>
                                        <Link component="button" onClick={() => setMaterialDialogOpen(true)} className={classes.labelNoto12Bold400_hh} sx={{ color: '#1976d2', textDecoration: 'underline' }}>View All</Link>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {spLotInfo.materials.slice(0, 5).map((mat, index) => (
                                            <Chip key={index} label={typeof mat === 'string' ? mat : mat.matid || DASH_PLACEHOLDER} size="small" sx={{ fontWeight: 600, fontSize: '0.975rem', borderRadius: '5px' }} />
                                        ))}
                                        {spLotInfo.materials.length > 5 && (
                                            <Chip label={`+${spLotInfo.materials.length - 5} more`} size="small" sx={{ fontWeight: 600, fontSize: '0.975rem', backgroundColor: '#e0e0e0', borderRadius: '5px' }} />
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Collapse>
        </>
    );
};

export default ProcessingInfoCard;
